(function () {
  const CHECKOUT_BTN = '.rebuy-cart__checkout-button';
  const REDIRECT_BTN = '.redirect-cart-button.button.rebuy-button';
  const NOTES_TOGGLE = '.rebuy-cart__notes-toggle-input';
  const NOTES_TEXTAREA = '#rebuy-cart__notes';
  const OVERLAY_ID = 'wbyg-overlay';

  let bypassCheck = false;

  function hasGiftMessage() {
    // If Giftnote app is active, its label switches to 'Edit Gift Message' when a note is saved
    const label = document.querySelector('.rebuy-cart__notes-toggle-label');
    if (label && label.textContent.trim() === 'Edit Gift Message') return true;
    // Fallback: native Rebuy textarea
    const textarea = document.querySelector(NOTES_TEXTAREA);
    return textarea && textarea.value.trim().length > 0;
  }

  function scrollIntoScrollParent(el) {
    const scrollArea = document.querySelector('[data-rebuy-cart-scroll-area]');
    if (scrollArea) {
      const areaRect = scrollArea.getBoundingClientRect();
      const elRect = el.getBoundingClientRect();
      scrollArea.scrollTo({
        top: scrollArea.scrollTop + (elRect.top - areaRect.top) - 20,
        behavior: 'smooth',
      });
      return;
    }
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function openNotesAndFocus() {
    const toggle = document.querySelector(NOTES_TOGGLE);
    const wasCollapsed = toggle && !toggle.checked;
    if (wasCollapsed) toggle.click();

    const notesEl = document.querySelector('[data-rebuy-component="notes"]');
    if (!notesEl) return;

    // Query textarea inside the timeout — Vue may not have rendered it yet
    setTimeout(function () {
      const textarea = document.querySelector(NOTES_TEXTAREA);
      scrollIntoScrollParent(notesEl);
      if (textarea) textarea.focus();
    }, wasCollapsed ? 350 : 50);
  }

  function removeOverlay() {
    const existing = document.getElementById(OVERLAY_ID);
    if (existing) existing.remove();
  }

  function showModal(triggerBtn) {
    removeOverlay();

    const overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'wbyg-title');

    const modal = document.createElement('div');
    modal.className = 'wbyg-modal';

    modal.innerHTML = [
      '<button id="wbyg-close" aria-label="Close">&times;</button>',
      '<p id="wbyg-title">Wait, before you go!</p>',
      '<p class="wbyg-subtitle">Would you like to add a Gift Message to your order?</p>',
      '<div class="wbyg-actions">',
        '<p class="wbyg-note">Please note: For multiple addresses, you can add individual messages during address entry.</p>',
        '<button id="wbyg-add"><span>Yes, Add a Gift Message</span></button>',
        '<button id="wbyg-continue">No thanks, Continue to Checkout</button>',
      '</div>',
    ].join('');

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) removeOverlay();
    });

    document.getElementById('wbyg-close').addEventListener('click', removeOverlay);

    document.getElementById('wbyg-add').addEventListener('click', function () {
      removeOverlay();
      openNotesAndFocus();
    });

    document.getElementById('wbyg-continue').addEventListener('click', function () {
      removeOverlay();
      bypassCheck = true;
      triggerBtn.click();
    });

    function onKeyDown(e) {
      if (e.key === 'Escape') {
        removeOverlay();
        document.removeEventListener('keydown', onKeyDown);
      }
    }
    document.addEventListener('keydown', onKeyDown);
  }

  // Single capture-phase listener on document — runs before Vue's handlers
  document.addEventListener(
    'click',
    function (event) {
      const triggerBtn =
        event.target.closest(CHECKOUT_BTN) ||
        event.target.closest(REDIRECT_BTN);

      if (!triggerBtn) return;

      if (bypassCheck) {
        bypassCheck = false;
        return;
      }

      if (!hasGiftMessage()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showModal(triggerBtn);
      }
    },
    true // capture phase
  );
})();
